import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import { useBreakpoint } from "../../../hooks";
import FocusServiceCard from "../../cards/FocusServiceCard";
import { ConditionalSwiper } from "../../shared/conditionalSwiper";

const ProgramImpactfulTravel = () => {
  const { sectionDetails } = useStaticQuery(graphql`
    query {
      sectionDetails: wp {
        ingoPrograms: acfOptionsIngoProgramsConfig {
          ingoPrograms {
            journeysGlobalFundsSpent
            jitSectionTitle
            jitFeatureList {
              jitFeatureListTitle
              jitFeatureListLinkUrlTarget
              jitFeatureListLinkUrl
              jitFeatureListLinkLabel
              jitFeatureListIcon {
                ...smallGalleryData
              }
            }
          }
        }
      }
    }
  `);

  const beyondBordersDetails = sectionDetails?.ingoPrograms?.ingoPrograms || [];
  const breakpoint = useBreakpoint();

  const sectionTitle = beyondBordersDetails?.jitSectionTitle || "";
  const list =
    beyondBordersDetails?.jitFeatureList?.map((item) => {
      return {
        title: item.jitFeatureListTitle,
        description: `<a
            rel="noopener"
            title=${item?.jitFeatureListLinkLabel || ""}
            href=${item?.jitFeatureListLinkUrl || "#"}
            target=${item?.jitFeatureListLinkUrlTarget ? "_gviblank" : "_self"}
            class="underline underline-offset-2 text-black-lighter visited:text-black-lighter visited:planet:text-white planet:text-white hover:text-yellow-lighten hover:planet:text-green-standard"
          >
            ${item?.jitFeatureListLinkLabel || ""}
          </a>`,
        icon: item?.jitFeatureListIcon || <></>
      };
    }) || [];

  if (list?.length < 1) {
    return <></>;
  }

  return (
    <section className="w-full border-t border-gray-generic planet:border-black-quaternary py-8 sm:py-12">
      <div className="w-full flex flex-col gap-8 sm:gap-12">
        <h6
          className="w-full font-light text-generic-text planet:font-bold text-xl md:text-xlrg-sm planet:text-white sm:leading-10 sm:w-10/12 2xl:w-full"
          dangerouslySetInnerHTML={{
            __html: sectionTitle
          }}
        />

        {list?.length > 0 && (
          <div className="w-full h-full relative gap-4 sm:gap-10 grid grid-flow-row-dense grid-cols-1 md:grid-cols-3 auto-rows-max">
            <ConditionalSwiper
              condition={breakpoint === "xs"}
              slidesPerView={2.25}
              spaceBetween={10}
              centeredSlides={false}
              className="h-full w-full"
            >
              {list &&
                list?.map((include, index) => (
                  <>
                    <FocusServiceCard
                      key={`pit-focus-${index}`}
                      title={include?.title}
                      description={include?.description}
                      icon={include?.icon}
                      containerClass="group h-full gap-3 flex flex-col"
                      contentClass="flex flex-1 flex-col"
                      contentTitleClass="w-full py-2 text-xl font-normal font-alice text-generic-text planet:text-white"
                      descriptionClass="w-full text-generic-text planet:text-gray-generic xxs:text-xs flex-1 flex flex-col justify-end"
                      imageOuterContainerClass="fservice-card-icon"
                      titleClass=""
                      imageClass="h-10"
                      imageContainerClass=""
                    />
                  </>
                ))}
            </ConditionalSwiper>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProgramImpactfulTravel;
